module.exports = __webpack_public_path__ + "static/media/mobileMenu1.f95e89b8.jpeg";